/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useContext } from 'react';
import { DossierDocumentSign } from './types';

const dossiers: Array<DossierDocumentSign> = [];

let selectedDossier: DossierDocumentSign | undefined;

const loading: boolean = true;

const loadDossiers = () => {};

const setSelectedDossier: React.Dispatch<
    React.SetStateAction<DossierDocumentSign | undefined>
> = () => {};

const isRaisable = (id: number): boolean => false;

const getDossiersBySignedFileId = (fichierId: number): Array<DossierDocumentSign> => [];

const DossierDocumentSignContext = createContext({
    dossiers,
    selectedDossier,
    loading,
    loadDossiers,
    setSelectedDossier,
    isRaisable,
    getDossiersBySignedFileId,
});

export const useDossierDocumentSignContext = () => useContext(DossierDocumentSignContext);

export default DossierDocumentSignContext;
